// dependecies import ==>
import React, { useEffect, useState, useRef } from "react";
import Popover from "react-popover";
// assets and scss import ==>
import "./futureAppointmentsView.scss";
import infoIcon from "../../../assets/info.png";
// constant import ==>
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { GET_FUTURE_APPOINTMENTS_API } from "../APIHandler/apiConstants";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import { c2cGetApiHandler } from "../../../Util/c2cApiHandler";
import { USER_ROLE } from "../../../Util/constants";

const FutureAppointmentsView = (props) => {
  const { patientAccountId, doctorId } = props;
  const [futureAppointmentList, setFutureAppointmentList] = useState([]);
  const [appointmentListFlag, setAppointmentListFlag] = useState(false);
  const [popoverId, setPopoverId] = useState("");
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [futureAppoinmentTotalApiCount, setFutureAppointmentTotalApiCount] =
    useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const futureAppointmentListRef = useRef();
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  const isConsultantOrIndividualDoctor =
    !clinicId ||
    [USER_ROLE?.DOCTOR_CONSULTANT, USER_ROLE?.RESOURCE_CONSULTANT].includes(
      doctorRole
    );

  let details = {
    patientAccountId: patientAccountId,
    doctorId: doctorId,
    clinicId: clinicId ?? "",
  };

  //life cycle methods ==>

  useEffect(() => {
    getFutureAppointmentsApiCall();
  }, [patientAccountId]);

  const getFutureAppointmentsApiCall = () => {
    let params = {
      patient_id: details.patientAccountId,
      clinic_id: details.clinicId,
      page_no: currentPageNo,
      records_per_page: 5,
    };
    if (isConsultantOrIndividualDoctor) {
      params.doctor_id = doctorId;
    }
    let futureAppointments = c2cGetApiHandler(
      GET_FUTURE_APPOINTMENTS_API,
      params
    );
    futureAppointments
      .then(([res, error]) => {
        if (!error && res?.data?.statusCode === 200) {
          setFutureAppointmentTotalApiCount(
            Math.ceil(res?.data?.total_records / res?.data?.records_per_page)
          );
          setCurrentPageNo((prev) => prev + 1);
          setIsFetching(false);
          if (futureAppointmentList?.length > 0) {
            setFutureAppointmentList((prev) => [...prev, ...res?.data?.data]);
          } else {
            setFutureAppointmentList([...res?.data?.data]);
          }
        } else {
          setFutureAppointmentList([]);
        }
      })
      .catch((error) => {
        setFutureAppointmentList([]);
        C2CConsole.log(error);
      });
  };

  //<==

  // handlers

  const toggleAppointmentList = () => {
    setAppointmentListFlag(!appointmentListFlag);
  };

  const handlePopoverOpen = (id) => {
    setPopoverId(id);
    setIsPopoverOpen(true);
  };
  const handlePopoverClose = () => {
    setIsPopoverOpen(false);
    setPopoverId("");
  };

  const handleScroll = () => {
    const container = futureAppointmentListRef?.current;
    if (!container) return;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 10) {
      if (!isFetching) {
        if (currentPageNo <= futureAppoinmentTotalApiCount) {
          setIsFetching(true);
          getFutureAppointmentsApiCall();
        }
      }
    }
  };

  // Create UI ===>
  const displayHoverContent = (data) => {
    if (Array.isArray(data)) {
      return (
        <ul>
          {data?.map((item) => (
            <li className="fali-popover-hover-msg">{item}</li>
          ))}
        </ul>
      );
    } else {
      return <div className="fali-popover-hover-msg">{data}</div>;
    }
  };

  const displayPopover = (id, hoverText, insideText) => {
    return (
      <Popover
        isOpen={id === popoverId && isPopoverOpen}
        className="fali-popover"
        preferPlace={`below`}
        body={displayHoverContent(hoverText)}
      >
        {insideText ? (
          <span
            className="fali-popover-text"
            onMouseOver={() => {
              handlePopoverOpen(id);
            }}
            onMouseOut={handlePopoverClose}
          >
            {insideText}
          </span>
        ) : (
          <img
            src={infoIcon}
            className="fali-info-img"
            alt=""
            onMouseOver={() => {
              handlePopoverOpen(id);
            }}
            onMouseOut={handlePopoverClose}
          />
        )}
      </Popover>
    );
  };

  const displayConsultationType = (index, consultationType) => {
    consultationType = consultationType?.split(",");
    const remainingTypes = consultationType?.slice(1);
    return (
      <>
        <span className="fali-value-consultation-type">
          {consultationType[0]}
        </span>
        {remainingTypes?.length > 0 && (
          <>
            {displayPopover(
              `${index}`,
              remainingTypes?.length == 1 ? remainingTypes[0] : remainingTypes,
              <span className="fali-value-consultation-type-count">
                +{remainingTypes?.length}
              </span>
            )}
          </>
        )}
      </>
    );
  };

  const futureAppointmentsList = () => {
    return futureAppointmentList?.map((item, index) => (
      <div key={index} className="future-appointment-list-item">
        <div className="fali-date-and-time">
          <span className="fali-circle"></span>
          <div className="fali-content">
            <div className="fali-label">Appointment Date & Time</div>
            <div className="fali-value fali-bold">{item?.date_and_time}</div>
          </div>
        </div>
        <div className="fali-consultatiton-type fali-border-none">
          <span className="fali-circle"></span>
          <div className="fali-content ">
            <div className="fali-label">Consultation Type</div>
            <div className="fali-value">
              {item?.consultation_type &&
                displayConsultationType(index, item?.consultation_type)}
            </div>
            <div className="fali-value">
              {item?.doctor_name?.length >= 30
                ? displayPopover(
                    `${index + item?.doctor_name}`,
                    item?.doctor_name,
                    `${item?.doctor_name?.slice(0, 30)}...`
                  )
                : item?.doctor_name}

              {item?.doctor_specialization && (
                <>
                  {displayPopover(
                    `${index + item?.doctor_specialization}`,
                    item?.doctor_specialization
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    ));
  };
  ///  <===

  const btnText = appointmentListFlag ? "-" : "+";
  return (
    <>
      {futureAppointmentList?.length > 0 && (
        <div className="future-appointment-view-container">
          <div className="future-appointment-container">
            <h4
              className="future-appointment-title"
              onClick={toggleAppointmentList}
            >
              Future Appointments <span className="fat-btn">{btnText}</span>
            </h4>

            {(window.innerWidth > 768 ||
              (window.innerWidth <= 768 && appointmentListFlag)) && (
              <div
                className="future-appointment-list"
                ref={futureAppointmentListRef}
                onScroll={handleScroll}
              >
                {futureAppointmentsList()}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default FutureAppointmentsView;
